// extracted by mini-css-extract-plugin
export default {"page":"Login_page__1ybUO","login":"Login_login__jJiFM","label_input":"Login_label_input__4O8GD","input_pass":"Login_input_pass__B16Hb","submit":"Login_submit__glxzR"};